import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/pl';

const isMobileSelect = window.matchMedia("only screen and (max-width: 760px)").matches;

export const Select2 = {
    name: 'Select2',
    props: ['options', 'value', 'placeholder', 'settings'],
    mounted() {
        this.init()
            .on('select2:select', (e) => {
                this.$emit('input', e.params.data.id);
                this.$emit('data', e.params.data);
            })
            .on('select2:opening', (e) => {
                openingSelect(e);
            })
            .on('select2:open', (e) => {
                openSelect(e);
            })
            .on('select2:close', () => {
                closeSelect();
            });
    },
    destroyed() {
        $(this.$el)
            .off()
            .select2('destroy');
    },
    methods: {
        init() {
            const result = $(this.$el)
                .empty()
                .select2({
                    data: this.options,
                    language: 'pl',
                    placeholder: this.placeholder,
                    closeOnSelect: true,
                    ...(this.settings || {})
                });

            if (this.value) {
                result.val(this.value).trigger('change');
                this.$emit('data', $(this.$el).select2('data')[0]);
            }
            return result;
        }
    },
    watch: {
        value(value) {
            $(this.$el)
                .val(value)
                .trigger('change');

            this.$emit('data', $(this.$el).select2('data')[0]);
        },
        options() {
            this.init();
        }
    },
    computed: {
        // filter out "change" event as it causes problems only
        allListeners() {
            const {input, ...listeners} = this.$listeners;
            return {
                ...listeners,
                input: (e) => {
                    input && input(e.target.value);
                }
            };
        }
    },
    template: `
        <select class="select" v-bind="$attrs" v-on="allListeners">
            <slot></slot>
        </select>
    `
};

function updateCountryStyles(e) {
    let options = document.getElementsByClassName("select2-results__option");
    for (let i = 0; i < options.length; i++) {
        if (options[i].innerHTML.indexOf('(') !== -1) {
            let strings = options[i].innerHTML.split("(");
            options[i].innerHTML = strings[0] + " <span style='font-size: 10px'>(" + strings[1] + "</span>";
        }
    }
}

export function openingSelect(e) {
    setTimeout(function () {
        $(".select2-results").css("visibility", "visible");
        let options = document.getElementsByClassName("select2-results__option");
        for (let i = 0; i < options.length; i++) {
            if (options[i].innerHTML.indexOf('(') !== -1) {
                let strings = options[i].innerHTML.split("(");
                options[i].innerHTML = strings[0] + " <span style='font-size: 10px'>(" + strings[1] + "</span>";
            }
        }
    }, 400);
}

export function openSelect(e) {
    let searchField = document.querySelector('.select2-search__field');
    searchField.addEventListener('input', updateCountryStyles);
    if (isMobileSelect) {
        document.body.classList.add('noscroll');
        document.querySelector('.select2-dropdown').classList.add('noscroll')
        document.querySelector('.select2-results').style.visibility = "hidden"
        searchField.classList.add('search-field__input')
        searchField.classList.add('input')
        searchField.placeholder = 'Szukaj kraju'

        let searchDiv = document.getElementsByClassName("search-field__button--right_block");
        if (searchDiv.length == 0) {
            let buttonDiv = document.createElement('div');
            buttonDiv.className = 'search-field__button search-field__button--right_block';
            searchField.parentNode.appendChild(buttonDiv);
        }

        let closeButton = document.querySelector('.select2-close-button');
        if (closeButton == null) {
            let closeDiv = document.createElement('div');
            closeDiv.className = 'select2-close-button';
            closeDiv.onclick = function () {
                $('.select.select2-hidden-accessible').select2('close');
                document.body.classList.remove('noscroll');
            }
            searchField.parentNode.insertBefore(closeDiv, searchField);
        }

        let createdSpan = document.querySelector('.select2-layout__header');
        if (createdSpan == null) {
            let span = document.createElement('span');
            if(e.currentTarget.id=='countryFrom' || e.currentTarget.name=='sender_country'){
                span.innerHTML = 'Wybierz kraj nadania';
            } else if(e.currentTarget.id=='countryTo' || e.currentTarget.name=='recipient_country'){
                span.innerHTML = 'Wybierz kraj odbioru';
            } else if(e.currentTarget.name=='carrier'){
                span.innerHTML = 'Wybierz kuriera';
            } else {
                span.innerHTML = 'Wybierz kraj';
            }
            span.className = 'select2-layout__header';
            searchField.parentNode.insertBefore(span, searchField);
        }
    } else {
        if (searchField) {
            searchField.focus();
        }
    }
}

export function closeSelect() {
    document.body.classList.remove('noscroll');
    let selectedSearch = document.querySelector('.select2-search__field');
    if (selectedSearch) {
        selectedSearch.focus();
    }
}

document.onkeydown = function (evt) {
    let isEscape = false;
    if ("key" in evt) {
        if(evt.key === "Escape" || evt.key === "Esc") {
            document.body.classList.remove('noscroll');
        }
    }
};
